import PropTypes from 'prop-types'

export const ScrollToBottomButton = ({ onClick, show }) => {
  if (!show) return null

  return (
    <div className="absolute bottom-32 left-1/2 -translate-x-1/2 z-10">
      <button
        onClick={onClick}
        className="bg-gray-800/90 backdrop-blur-sm w-14 h-14 rounded-full shadow-xl hover:shadow-2xl hover:scale-105 hover:bg-gray-700/90 transition-all duration-300 flex items-center justify-center animate-fade-in-only border border-white/20"
        aria-label="Scroll to new messages"
      >
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </svg>
      </button>
    </div>
  )
}

ScrollToBottomButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
